import { render, staticRenderFns } from "./giveawayRefundModal.vue?vue&type=template&id=5784fcc0&scoped=true"
import script from "./giveawayRefundModal.vue?vue&type=script&lang=ts"
export * from "./giveawayRefundModal.vue?vue&type=script&lang=ts"
import style0 from "./giveawayRefundModal.vue?vue&type=style&index=0&id=5784fcc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784fcc0",
  null
  
)

export default component.exports